<div class="pc-contact">

    <app-profile-section-header title="Domiciliaciones"
                                subtitle="Gestiona tus cuentas bancarias y la vinculación con tus pólizas">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
            <circle cx="12" cy="8" r="4"/>
            <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <button headerActions class="edit-card__edit-btn" (click)="onEditClick()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="18" height="18">
                        <path d="M4 20h4l10-10-4-4L4 16v4z" stroke-linejoin="round"/>
                        <path d="M14 6l4 4" stroke-linecap="round"/>
            </svg>
            <span>Editar datos bancarios</span>
        </button>
    </app-profile-section-header>

    <div class="pc-card" *ngIf="paymentData && paymentData.length > 0">
        <h3 class="pc-card-title"><span class="pc-card-bar"></span>Datos bancarios</h3>
        <div class="pc-grid pc-grid-banking" *ngFor="let item of paymentData">
            <div class="pc-field">
                <label>Póliza</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <div class="pc-field-multiline">
                        <span>{{ item.number || '' }}</span>
                        <span class="pc-field-sub">{{ item.product || '' }}</span>
                    </div>
                </div>
            </div>
            <div class="pc-field">
                <label>Cuenta bancaria</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <rect x="2" y="6" width="20" height="12" rx="2"/>
                                    <line x1="2" y1="10" x2="22" y2="10"/>
                        </svg>
                    </span>
                            <span>{{ item.bankAccount || '' }}</span>
                </div>
            </div>
            <div class="pc-field">
                <label>Tipo de pago</label>
                <div class="pc-field-value">
                    <span class="pc-field-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                                    <rect x="3" y="5" width="18" height="16" rx="2"/>
                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                    <line x1="8" y1="3" x2="8" y2="7"/>
                                    <line x1="16" y1="3" x2="16" y2="7"/>
                        </svg>
                    </span>
                            <span>{{ item.periodicity || '' }}</span>
                </div>
            </div>
        </div>
    </div>

</div>